import { forwardRef } from "react";
import PropTypes from "prop-types";
import { FormControl } from "./FormControl";

export const TextArea = forwardRef((props, ref) => (
  <FormControl
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    componentClass="textarea"
    ref={ref}
  />
));

TextArea.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(["default", "small", "large", "auto"]),
  variant: PropTypes.oneOf(["default", "unstyled"]),
};

TextArea.defaultProps = {
  className: "",
  size: "default",
  variant: "default",
};

export default TextArea;
